import { Component, ViewEncapsulation } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { param } from "jquery";
import { ExportFormatEnum } from "src/app/_models";
import { ICONS } from "src/app/_helpers/icons.constants";

@Component({
    selector: 'app-export-log-action-renderer',
    templateUrl: './export-log-action-renderer.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ExportLogActionRendererComponent {
  ICONS = ICONS;
  Xeroaction : string = "XeroAction";
  viewdetailaction : string = "ViewDetailAction";
  actionButtons: any[] = [];
  params: ICellRendererParams;
  data : any ={};
  constructor() {

  }

  get exportFormatEnum() {
    return ExportFormatEnum;
  }

  onUserAction(action) {
    this.params.data.userAction = action;
    this.params.node.setData(this.params.data);
    this.params.eGridCell.click();
  }

  // Download calls the host directly rather than re-dispatching through
  // eGridCell.click(), so it doesn't have to share the userAction switch with
  // the other buttons — see cellRendererParams.onDownload on the column.
  onDownloadAction(event: Event) {
    event.stopPropagation();
    const onDownload = (this.params as any)?.onDownload;
    if (onDownload) {
      onDownload(this.params.data);
    }
  }


  initilize(params: ICellRendererParams) {
    if (params && params.data) {
      this.params = params;
      this.data = params.data;
      this.actionButtons = JSON.parse(JSON.stringify(params.colDef?.headerComponentParams));
    }
    else {
      this.actionButtons = [];
    }
  }


  // called on init
  agInit(params: any): void {
    this.initilize(params);
  }

  // called when the cell is refreshed
  refresh(params: any): boolean {
    this.initilize(params);
    return true;
  }
}
